import { Button, ButtonGroup, FileUpload, Modal as TwsModal } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { DistributionFileUploadType, IDistributionFile, IValidationErrorCollection } from '../../../models';
import { FileUploadError } from './FileUploadError';
import { FileUploadWarning } from './FileUploadWarning';

const Modal = styled(TwsModal)`
	.modal-content {
		min-height: 500px;
		text-align: center;
	}

	& .tws-button-group {
		align-items: start;
	}
`;
Modal.displayName = 'Modal';
const DownloadButton = styled(Button)`
	&.btn {
		margin-right: 10px;
	}
`;
const ButtonGroupContainer = styled('div')`
	margin: 40px 0;
	text-align: center;
`;
ButtonGroupContainer.displayName = 'ButtonGroupContainer';

export interface IAppendDistributionModalProps {
	distributionType?: number;
	file?: any;
	fileUploadType?: DistributionFileUploadType;
	distributionValidationErrors?: IValidationErrorCollection;
	distributionValidationWarnings?: IValidationErrorCollection;
	instructionsText: string;
	isUploading: boolean;
	modalOpen: boolean;
	titleText: string;
	validateOnly: boolean;
	closeAfterValidate?: boolean;
	showUploadButton?: boolean;
	selectedDistribution?: IDistributionFile;
	closeModal: () => void;
	downloadTemplate: () => void;
	onAppend?: (file: any) => void;
	appendDistribution?: (file: any, distributionType?: number) => any;
	validateFile?: (fileUploadType: DistributionFileUploadType, file: any, distributionType?: number) => any;
}

export class AppendDistributionModal extends React.Component<IAppendDistributionModalProps, {}> {
	constructor(props: IAppendDistributionModalProps) {
		super(props);

		this.uploadButtonChange = this.uploadButtonChange.bind(this);
		this.appendButtonClick = this.appendButtonClick.bind(this);
	}

	public UNSAFE_componentWillReceiveProps(nextProps: IAppendDistributionModalProps) {
		if ((nextProps.closeAfterValidate || !nextProps.selectedDistribution) && !nextProps.distributionValidationErrors && nextProps.file) {
			nextProps.closeModal();
		}
	}

	public render() {
		const {
			closeModal,
			distributionValidationErrors,
			distributionValidationWarnings,
			isUploading,
			modalOpen,
			downloadTemplate,
			titleText,
			instructionsText,
			showUploadButton,
			file,
		} = this.props;

		return (
			<>
				<Modal
					isOpen={modalOpen}
					title={titleText}
					hideFooter={showUploadButton ? false : true}
					contenthcentered={true}
					contentvcentered={true}
					contentfullwidth={false}
					type={'lightbox'}
					primaryButtonText={showUploadButton ? ContentConstants.BUTTONS_APPEND_DISTRIBUTION_LIST : undefined}
					secondaryButtonText={showUploadButton ? ContentConstants.BUTTONS_CLOSE : undefined}
					primaryButtonDisabled={distributionValidationErrors !== undefined || !file || isUploading}
					secondaryButtonDisabled={isUploading}
					onSubmit={this.appendButtonClick}
					onSecondaryButtonClick={closeModal}
					onClosed={closeModal}
				>
					<div>
						<div className={'tws-append-distribution-instruction-text'}>{instructionsText}</div>
						<ButtonGroupContainer>
							<ButtonGroup type='column' reversed={false}>
								<DownloadButton id='btnDownloadTemplate' color='secondary' onClick={downloadTemplate}>
									{ContentConstants.BUTTONS_DOWNLOAD_TEMPLATE}
								</DownloadButton>
								<FileUpload
									btnTitle={ContentConstants.BUTTONS_UPLOAD_FILE}
									btnColor={'primary'}
									getValue={this.uploadButtonChange}
									multiple={false}
									iconName='upload'
									fileNameLabelWidth={'250px'}
									disabled={isUploading}
									error={distributionValidationErrors !== undefined}
									files={file ? file.name : undefined}
								/>
							</ButtonGroup>
						</ButtonGroupContainer>

						{distributionValidationErrors && <FileUploadError distributionValidationErrors={distributionValidationErrors} />}
						{distributionValidationWarnings && <FileUploadWarning distributionValidationWarnings={distributionValidationWarnings} />}
					</div>
				</Modal>
			</>
		);
	}

	public uploadButtonChange(files: any) {
		const { distributionType, validateOnly, appendDistribution, validateFile } = this.props;
		if (files && files.length > 0) {
			if (validateOnly && validateFile) {
				validateFile(DistributionFileUploadType.Append, files[0], distributionType);
			}
			if (!validateOnly && appendDistribution) {
				appendDistribution(files[0], distributionType);
			}
		}
	}

	public appendButtonClick() {
		const { file, distributionType, appendDistribution } = this.props;
		if (file && appendDistribution) {
			appendDistribution(file, distributionType);
		}
	}
}
